package com.rainbowclubs.rainbow.data.cache

import io.ktor.client.*
import io.ktor.client.plugins.auth.*
import io.ktor.client.plugins.auth.providers.*

class BearerTokenCache(
    private val httpClient: HttpClient,
) {
    fun clear() {
        httpClient.authProvider<BearerAuthProvider>()?.clearToken()
    }
}
